module AppKitchen {

    export module Starter {

        function getBrowserCulture() {
            var nav = <any>navigator;
            var userLang = nav.language || nav.userLanguage || (nav.languages ? nav.languages[0] : null);

            var cultureMap = {
                "de-DE": "de-DE",
                "de": "de-DE",
                "en-US": "en-US",
                "en": "en-US"
            }

            var culture = "en-US"; // default language

            if (userLang && cultureMap[userLang]) {
                culture = cultureMap[userLang];
            } else {
                var shortLanguage = userLang.slice(0, 2);
                if (cultureMap[shortLanguage]) {
                    culture = cultureMap[shortLanguage.toLowerCase()];
                }
            }

            return culture;
        }

        function loadScript(main: string, fallback: string, success: () => any, fail: (error) => any) {
            $.getScript(main + ".min.js", success).fail(() => {
                $.getScript(main + ".js", success).fail(() => {
                    $.getScript(fallback + ".min.js", success).fail(() => {
                        $.getScript(fallback + ".js", success).fail(fail);
                    });
                });
            });
        }

        export function startup(targetContainer: HTMLElement, ressourcesLocations: string[], apiUrl: string, appKitchenApiUrl: string, startApp: (container: HTMLElement) => any) {
            // start delayed loading animation (if startup enough quick do not show animation at all)

            var appStarted = false;
            var startupError = false;
            setTimeout(() => {
                if (!appStarted && !startupError) {
                    AppKitchen.UIHelper.renderLoader(targetContainer, {size: "L"});
                }
            }, 500);

            AppKitchen.Data.setAPIs(apiUrl, appKitchenApiUrl);

            var globalSettingsLoaded = false;
            var loadedRessourcesCount = 0;

            // set culture to browser culture if no culture in GlobalSettings
            if (!AppKitchen.GlobalSettings.culture) {
                AppKitchen.GlobalSettings.culture = getBrowserCulture();
            }

            // set kendo culture
            kendo.culture(AppKitchen.GlobalSettings.culture);

            var tryToStartApp = () => {
                if (loadedRessourcesCount === ressourcesLocations.length && globalSettingsLoaded) {
                    appStarted = true;
                    initGeneralCode();
                    AppKitchen.UIHelper.removeLoader(targetContainer,
                        { fadeOut: 300, complete: () => startApp(targetContainer) });
                }
            }

            var throwStartupError = (userFriendlyMessage: string, debugMessage: string) => {
                startupError = true;
                $(targetContainer).append('<div class="a-startup-error">App can not be started due to the following reason:<br>' + userFriendlyMessage + '<div>');
                AppKitchen.UIHelper.removeLoader(targetContainer, {fadeOut: 0});
                throw debugMessage;
            }

            for (let i = 0; i < ressourcesLocations.length; i++) {
                var currentFolder = ressourcesLocations[i];
                var mainFile = currentFolder + "/Resources." + AppKitchen.GlobalSettings.culture;
                var fallBack = currentFolder + "/Resources.en-US.min.js";
                loadScript(mainFile, fallBack, () => {
                    loadedRessourcesCount++;
                    tryToStartApp();
                }, error => {
                    throwStartupError("Configuration error", "Resource scripts at following locations could not be found:\r\n" + ressourcesLocations.join("\r\n") + "\r\n" + error.message);
                });
            }

            AppKitchen.Data.Api.getGlobalSettings(serverSettings => {
                AppKitchen.GlobalSettings.pingInterval = serverSettings.PingInterval;
                AppKitchen.GlobalSettings.pingTimeout = serverSettings.PingTimeout;
                AppKitchen.GlobalSettings.securityTokenServiceOAuthUrl = serverSettings.SecurityTokenServiceOAuthUrl;
                AppKitchen.GlobalSettings.welcomeMessage = serverSettings.WelcomeMessage;
                AppKitchen.GlobalSettings.loginTheme = serverSettings.LoginTheme;
                AppKitchen.GlobalSettings.sessionTokenCookieName = serverSettings.SessionTokenCookieName;
                AppKitchen.GlobalSettings.currentUserCookieName = serverSettings.CurrentUserCookieName;
                AppKitchen.GlobalSettings.applicationName = serverSettings.ApplicationName;
                AppKitchen.GlobalSettings.applicationVersion = serverSettings.ApplicationVersion;
                AppKitchen.GlobalSettings.applicationCopyright = serverSettings.ApplicationCopyright;
                AppKitchen.GlobalSettings.customConfig = serverSettings.CustomConfig;
                globalSettingsLoaded = true;
                tryToStartApp();
            }, error => { throwStartupError("Server not reachable", "Failed to read global settings from server: " + error.message); });

            AppKitchen.ChangeManager.startCheckForUpdates();
        }

        function initGeneralCode()
        {
            // init general part (for portal code sharing)
            General.GeneralLogger.init(AppKitchen.log, AppKitchen.logError);
            General.TsChart.Preloadtransformations.Templates.preloadTransformationCombobox = AppKitchen.Templates.PreloadTransformation_Combobox;
            General.GeneralRenderer.init((template, data, container) => {
                AppKitchen.UIHelper.renderTemplateTo(container, template, data);
            });
        }
    }
}